module.exports = __webpack_public_path__ + "static/media/Reman_Major_SwingMotor_xparent.4d63b753.png";